import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitWord'
})
export class SplitWordPipe implements PipeTransform {

  transform(value: string): any {
    if(value.includes(' ')){
      return value.split(' ')[0]
    } else {
      return value
    }
  }
}
